import React from "react";
import { CustomButton } from "../../Common/Components/Button/CustomButton";
import { CheckMobile } from "../../AppSystem/Helpers/CheckMobile";

// Create-button row for the system settings list tabs, styled like the ReportProceedingList create button.
// On mobile the button becomes full width and, unless mobileFixed is false, sticks to the bottom
// of the screen like in ReimbursementHeaderMobile (rhm-create-btn-wrap).
export const SettingsListHeader = ({ createText, onCreate, showCreate = true, mobileFixed = true }) => {
    const isMobile = CheckMobile(998);

    if (!showCreate || !onCreate) return null;

    const button = (
        <CustomButton
            buttonWidth="block"
            customClasses="justify-content-center reimbursement-create-btn"
            text={createText}
            icon="bx bxs-plus-circle pe-2"
            buttonColor="#084F35"
            hoverButtonColor="#157553"
            onClick={onCreate}
            buttonSize="big"
        />
    );

    if (isMobile && mobileFixed) {
        // The bottom space for this fixed bar is reserved by AdminSystemSettings (mobile padding)
        return <div className="rhm-create-btn-wrap">{button}</div>;
    }

    if (isMobile) {
        return <div className="mb-3">{button}</div>;
    }

    return (
        <div className="d-flex justify-content-end mb-3">
            <div>{button}</div>
        </div>
    );
};
